import { useCallback, useState } from 'react';
import InvoicePreviewModal from '../components/invoices/InvoicePreviewModal';

export const useInvoicePreviewModal = () => {
  const [invoiceId, setInvoiceId] = useState<number | null>(null);

  const openInvoicePreview = useCallback((id: number) => {
    if (Number.isFinite(id) && id > 0) {
      setInvoiceId(id);
    }
  }, []);

  const closeInvoicePreview = useCallback(() => {
    setInvoiceId(null);
  }, []);

  const invoicePreviewModal =
    invoiceId != null ? (
      <InvoicePreviewModal invoiceId={invoiceId} onClose={closeInvoicePreview} />
    ) : null;

  return {
    invoiceId,
    openInvoicePreview,
    closeInvoicePreview,
    invoicePreviewModal,
  };
};
